import * as config from '../../config';
import { createAction } from 'redux-actions';
import {
  restoreDishesLocalStorage,
  storeDishesLocalStorage,
  deleteOldDishCookie,
  clearDishesLocalStorage,
  getOrderedDishes,
  getDishBoxprice,
  getFullscreenAdShow,
} from '../../helper/dish-helper';
import { clearTableInfoInSessionStorage, getTableInfoInSessionStorage } from '../../helper/order-dinner-cart-helper';
import { getUrlParam, getUrlParams, getRecommendDish, interValSetting, getRunEnv } from '../../helper/common-helper';
import httpRequest, { get } from '../../helper/http-request-helper';
import fetchHelper from '../../helper/fetch-helper';
import router from '../../router';
import pageHelper from '../../helper/page-helper';
import { INDUSTRY, MemberPrivTypes, STRATEGY_TYPE } from '../../helper/const';
// eslint-disable-next-line
import { getAddressByPoint, getTransformedLocation } from '../../helper/map-TARGET_AREA';

import { formatMessage } from '../../intl/helper';
import actionText2 from '../../intl/messages/action/part2';

exports.setServiceStatus = createAction('SET_SERVICE_STATUS', serviceStatus => serviceStatus);
const setIndustryInfo = createAction('SET_INDUSTRY_INFO', industry => industry);
const setMenuData = createAction('SET_MENU_DATA', menuData => menuData);
const setShopInfo = createAction('SET_SHOP_INFO', shopInfo => shopInfo);
const setDataInitOver = createAction('SET_DATA_INIT_OVER', isOver => isOver);
const _orderDish = createAction('ORDER_DISH', (dishData, action) => [dishData, action]);
const changeDish = createAction('CHANGE_DISH', (dishData, action) => [dishData, action]);
const _removeAllOrders = createAction('REMOVE_ALL_ORDERS', orders => orders);
const _clearSaveOrder = createAction('CLEAR_SAVE_ORDER', orders => orders);
const _reinstateUndefined = createAction('REINSTATE_UNDEFINED', orders => orders);
const _setTakeawayServiceProps = createAction('SET_TAKEAWAY_SERVICE_PROPS', props => props);
const setDiscountToOrder = createAction('SET_DISCOUNT_TO_ORDER', discount => discount);
const setBatchOrderDish = createAction('BATCH_ORDER_DISH', dishList => dishList);
const setNormalDiscount = createAction('SET_NORMAL_DISCOUNT', discount => discount);
const setCouponSuccessInfo = createAction('SET_COUPON_SUCCESS_INFO', couponSuccessInfo => couponSuccessInfo);
const setCouponSuccess = createAction('SET_COUPON_SUCCESS', couponSuccess => couponSuccess);
const setErrorMsg = (exports.setErrorMsg = createAction('SET_ERROR_MSG', error => error));
const setLoadMsg = createAction('SET_LOAD_MSG', loadinfo => loadinfo);
const setTableAreaInfo = createAction('SET_TABLE_AREA_INFO', tableAreaInfo => tableAreaInfo);
// 设置店铺的营业状态 - 外卖和堂食点餐
const setShopOrderStatus = createAction('SET_SHOP_ORDER_STATUS', shopOrderStatus => shopOrderStatus);
const setPageLoadedStatus = (exports.setPageLoadedStatus = createAction('SET_PAGE_LOADED_STATUS', pageLoadedStatus => pageLoadedStatus));
const setSoldDishList = createAction('SET_SOLD_DISH_LIST', soldTopDishList => soldTopDishList);
const setGuidStatus = createAction('SET_GUID_STATUS', status => status);

const setCallMsg = (exports.setCallMsg = createAction('SET_CALL_MSG', callInfo => callInfo));
exports.setCancelCanMsg = createAction('SET_CANCEL_CALL_MSG', callInfo => callInfo);
const setCanCall = (exports.setCanCall = createAction('SET_CAN_CALL', callAble => callAble));
const setDeliveryTime = createAction('SET_DELIVERY_TIME', deliveryTime => deliveryTime);
const setMustOrderDishList = createAction('SET_MUST_ORDER_DISH_LIST', list => list);
exports.activeDishType = createAction('ACTIVE_DISH_TYPE', (evt, dishTypeId, dishTypeIdIndex) => {
  window.__activeTypeByTap__ = evt && /dish-type-item/.test(evt.target.className);
  return { dishTypeId, dishTypeIdIndex };
});

const orderType = getUrlParam('type');
const shopId = getUrlParam('shopId');
const tableInfo = getTableInfoInSessionStorage(shopId);
const addDishStatus = getUrlParam('addDishes');
const tableId = getUrlParam('tableId') || sessionStorage.getItem('tableId') || tableInfo.tableId;
const tableKey = getUrlParam('tableKey') || tableInfo.tableKey;
const YDtime = getUrlParam('presetTime');

// 正餐先付
const payBeforeDinner = getUrlParam('payBeforeDinner');

const errorLocation = (errorCode, errorMsg) => {
  clearTableInfoInSessionStorage();
  sessionStorage.errorMsg = errorMsg || '未知';
  location.href = `${config.exceptionLinkURL}?shopId=${shopId}&linkType=1&diningForm=1`;
};

const getCoupontoGuid = (exports.getCoupontoGuid = (info, resolve) => (dispatch, getState) => {
  dispatch(setGuidStatus(info));

  if (resolve) {
    resolve();
  }
});

let dishListUrl = '';
let shopInfoUrl = '';
const runEnv = getRunEnv();
if (orderType !== 'WM') {
  dishListUrl = `${config.orderallDishListAPI}?shopId=${shopId}`;
  shopInfoUrl = `${config.orderallShopInfoAPI}?shopId=${shopId}&runEnv=${runEnv}`;

  if (YDtime) {
    dishListUrl = `${config.orderAllYDListAPI}?shopId=${shopId}&presetTime=${YDtime}`;
  }
} else {
  // 区分外送和自提
  dishListUrl = `${config.takeawayDishListAPI}?shopId=${shopId}`;
  shopInfoUrl = `${config.takeawayShopInfoAPI}?shopId=${shopId}&runEnv=${runEnv}`;
}

const getToShopFlagParam = function() {
  let hdlParam = '';
  if (orderType === 'WM') {
    const way = JSON.parse(localStorage.basicListInfo || '{}').way || 'ws'; // 默认外送
    const toShopFlag = way === 'ws' ? '0' : '1';
    hdlParam = `&toShopFlag=${toShopFlag}`;
  }
  return hdlParam;
};

exports.clearBell = msg => dispatch => {
  dispatch(
    setCallMsg({
      info: msg,
      callStatus: false,
    }),
  );
};

exports.callBell = (timer, contentCode, contentMsg) => (dispatch, getStates) => {
  const orderId = getStates().serviceStatus.orderId || '';
  dispatch(setCanCall(true));
  const callServiceAPI = `${config.callServiceAPI}?shopId=${shopId}&orderId=${orderId}&tableId=${tableId}&contentCode=${contentCode}&contentMsg=${contentMsg}`;

  return fetchHelper
    .get(callServiceAPI)
    .then((basicData = {}) => {
      dispatch(setCanCall(false));
      interValSetting(timer, () => {
        dispatch(setCanCall(true));
      });
      if (basicData.status.toString() === '1501') {
        // 已经呼叫过服务员了
        dispatch(
          setCallMsg({
            info: basicData.message,
            callStatus: true,
          }),
        );
        return;
      }
      dispatch(
        setCallMsg({
          info: '客官稍等，服务员马上就来',
          callStatus: true,
        }),
      );
    })
    .catch((err = {}) => {
      dispatch(
        setCallMsg({
          info: err.msg || '发送失败',
          callStatus: false,
        }),
      );
    });
};

exports.fetchIndustryInfo = () => dispatch => {
  const api = `${config.getIndustryApi}?shopId=${shopId}`;
  return fetchHelper
    .get(api)
    .then(data => {
      const { industry = INDUSTRY.NORMAL } = data || {};
      dispatch(setIndustryInfo(industry));
      return industry;
    })
    .catch(ex => {
      throw ex;
    });
};

exports.fetchShopInfo = () => dispatch => {
  dispatch(setPageLoadedStatus(false));

  return fetchHelper.get(shopInfoUrl).then(res => {
    if (!res) return;
    const data = res || {};
    data.showFullscreenAd = getFullscreenAdShow(data);
    dispatch(setShopInfo(data));

    // 在没有优惠券的情况下 主动弹出新手引导
    if (getUrlParam('getCoupon')) {
      dispatch(getCoupontoGuid(true));
    } else if (data.isOldMarketing && (!data.takeCouponVO || !data.takeCouponVO.coupId)) {
      // 老逻辑
      dispatch(getCoupontoGuid(true));
    } else if (!data.isOldMarketing && (!data.takeCouponVOS || data.takeCouponVOS.length === 0)) {
      // 新逻辑
      dispatch(getCoupontoGuid(true));
    }

    const { bizStatus } = data || {};

    if (bizStatus) {
      // 1,1,1,1 -> 堂食,外卖,预定,排队
      // 对于不同的堂食类型
      // 只有对应的状态码为 1 的时候，才接受点餐
      const isAcceptOrder =
        (bizStatus.slice(0, 1) === '1' && orderType === 'TS') ||
        (bizStatus.slice(2, 3) === '1' && orderType === 'WM') ||
        (bizStatus.slice(4, 5) === '1' && orderType === 'YD') ||
        (bizStatus.slice(6) === '1' && orderType === 'PD');
      dispatch(setShopOrderStatus(isAcceptOrder));
    }

    return data;
  });
};

exports.fetchMenuData = () => dispatch => {
  const hdlParam = getToShopFlagParam();
  return fetchHelper
    .get(`${dishListUrl}${hdlParam}`)
    .then(menuData => {
      if (!menuData) {
        dispatch(setErrorMsg({ text: '获取菜品出错，请刷新页面重试' }));
        return;
      }
      dispatch(setMenuData(restoreDishesLocalStorage(menuData)));
      // dispatch(setSoldDishList(menuData.data.soldTopInfos));
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg({ text: err.msg }));
    });
};

exports.fetchSoldDishList = () => dispatch => {
  return getRecommendDish((orderType || '').toLowerCase(), 'ordering_page')
    .then(recommendDishList => {
      dispatch(setSoldDishList({ dishMenuRecommendList: recommendDishList }));
      dispatch(setSoldDishList({ dishDetailRecommendList: recommendDishList }));
    })
    .catch(errMsg => dispatch(setErrorMsg({ text: errMsg })));
};

exports.dataInitIsOver = is => dispatch => {
  dispatch(setDataInitOver(is));
};

const getUserWay = () => JSON.parse(localStorage.basicListInfo || '{}').way || 'ws'; // 默认外送

const getTimeJson = rangeId => dispatch => {
  const way = getUserWay();
  const toShopFlag = way === 'ws' ? '0' : '1';
  return fetchHelper.post(`${config.queryDeliveryTime}`, { shopId, rangeId, toShopFlag }).then(result => {
    const { timeJson = {} } = result || {};
    const timeKeys = Object.keys(timeJson);
    if (timeKeys.length) {
      const date = timeKeys[0];
      const time = timeJson[date] && timeJson[date].length && timeJson[date][0];
      dispatch(setDeliveryTime(`${date} ${time}`));
    } else {
      dispatch(setDeliveryTime(''));
    }
  });
};

exports.fetchSendArea = () => dispatch => {
  if (orderType !== 'WM') {
    return false;
  }

  const basicListInfo = localStorage.getItem('basicListInfo') ? JSON.parse(localStorage.getItem('basicListInfo')) : null;
  const sendTypeFromLocal = basicListInfo && basicListInfo.way ? basicListInfo.way : 'ws'; // 默认外送
  const addressPromise =
    basicListInfo && basicListInfo.point
      ? getAddressByPoint({
          latitude: Number(basicListInfo.point.latitude),
          longitude: Number(basicListInfo.point.longitude),
        })
      : getTransformedLocation();
  const hasDefaultAddress = !!(basicListInfo && basicListInfo.point);

  const getDefaultSendArea = sendType => {
    addressPromise
      .then(({ province, city, district, street, latitude, longitude, mapType }) => ({
        latitude,
        longitude,
        mapType,
        currentAddress: `${province}${city}${district}${street}`,
        isGetLoc: true,
      }))
      .catch(() => ({ isGetLoc: false }))
      .then(params =>
        fetchHelper.get(config.getDefaultSendArea, {
          ...params,
          shopId,
          sendType,
        }),
      )
      .then(sendAreaData => {
        const sendTypeWord = sendType === 2 ? 'ws' : sendType === 3 ? 'zt' : '';
        const shipmentFee = sendAreaData.shipment || 0;
        const minPrice = sendAreaData.sendPrice || 0;
        const sendTime = sendAreaData.sendTime || 0;
        const id = sendAreaData.id;
        const shipFreePrice = typeof sendAreaData.freeDeliveryPrice === 'number' ? sendAreaData.freeDeliveryPrice : 9999999999;
        sessionStorage.setItem(`${sendTypeWord}_${shopId}_sendArea_id`, sendAreaData.id);
        sessionStorage.setItem(`${sendTypeWord}_${shopId}_sendArea_rangeId`, sendAreaData.id);
        sessionStorage.setItem(`${sendTypeWord}_${shopId}_sendArea_sendPrice`, minPrice);
        sessionStorage.setItem(`${sendTypeWord}_${shopId}_sendArea_shipment`, shipmentFee);
        sessionStorage.setItem(`${sendTypeWord}_${shopId}_sendArea_freeDeliveryPrice`, shipFreePrice);
        sessionStorage.setItem(`${sendTypeWord}_${shopId}_sendArea_sendTime`, sendTime);
        if (sendTypeFromLocal === sendTypeWord) {
          dispatch(
            _setTakeawayServiceProps({
              shipmentFee,
              minPrice,
              shipFreePrice,
              sendTime,
              id,
            }),
          );
        }

        // 如果有 sessionStorage.receiveOrderCustomerInfo 并且是外送
        if (hasDefaultAddress && sessionStorage.receiveOrderCustomerInfo && sendType === 2) {
          const receiveOrderCustomerInfo = JSON.parse(sessionStorage.receiveOrderCustomerInfo || '{}');
          (receiveOrderCustomerInfo.addresses || {}).rangeId = sendAreaData.id;

          sessionStorage.receiveOrderCustomerInfo = JSON.stringify(receiveOrderCustomerInfo);
        }
        if (sendTypeWord === getUserWay()) {
          getTimeJson(sendAreaData.id)(dispatch);
        }
      })
      .catch(error => {
        dispatch(setErrorMsg({ text: error.msg || error.message }));
      });
  };

  getDefaultSendArea(2); // 外送
  getDefaultSendArea(3); // 自提

  return true;
};

exports.orderDish = (dishData, action) => (dispatch, getStates) => {
  dispatch(_orderDish(dishData, action));
  dispatch(changeDish(dishData, action));
  storeDishesLocalStorage(getStates().dishesDataDuplicate, getStates().shopInfo);
};

exports.removeAllOrders = orders => dispatch => {
  dispatch(_removeAllOrders(orders));
  dispatch(_clearSaveOrder(orders));
  clearDishesLocalStorage();
};

exports.reinstateUndefined = orders => dispatch => {
  dispatch(_reinstateUndefined(orders));
};

exports.confirmOrder = (orderedDish) => (dispatch, getStates) => {
  const { dishesDataDuplicate, dishBoxChargeInfo, isAcceptOrder } = getStates();
  const orderedData = orderedDish || getOrderedDishes(dishesDataDuplicate);

  deleteOldDishCookie();

  if (!isAcceptOrder) {
    return;
  }

  if (orderType === 'TS') {
    if (payBeforeDinner) {
      location.href = `${config.orderall4DinnerURL}?type=${orderType}&shopId=${shopId}&payBeforeDinner=true`;
      return;
    }

    location.href = `${config.orderall4DinnerURL}?type=${orderType}&shopId=${shopId}`;
  } else {
    localStorage.setItem('dishBoxPrice', getDishBoxprice(orderedData, dishBoxChargeInfo));
    localStorage.setItem('dishBoxChargeInfo', JSON.stringify(dishBoxChargeInfo ? dishBoxChargeInfo.asMutable() : {}));
    location.href = `${config.takeout4DinnerURL}?type=${orderType}&shopId=${shopId}`;
  }
};

exports.fetchOrderAgain = () => (dispatch, getState) => {
  // const orderId = getUrlParam('orderId');
  const orderId = sessionStorage.orderId;
  if (!orderId) return;
  return fetchHelper
    .get(`${config.orderAgain}`, {
      shopId,
      orderId,
      toShopFlag: 1,
    })
    .then(res => {
      const { dishList = [], changed } = res || {};
      if (!dishList.length) return;
      dispatch(
        setBatchOrderDish({
          dishList,
          changed,
        }),
      );
    })
    .catch(err => {});
};

exports.fetchOrderDiscountInfo = discountRule => (dispatch, getState) => {
  const isHDL = getState().isHDL;

  return fetchHelper.get(`${config.orderDiscountInfoAPI}?shopId=${shopId}`, null, { enableDefaultResponseResolve: false }).then((response = {}) => {
    const res = response.data || {};
    if (!res || (res.code !== '200' && res.code !== 'NOT_LOGIN')) {
      dispatch(setErrorMsg({ text: res.msg }));
    }
    const { isMember = false, dishList = [], type } = res.data || {};
    const hasData = dishList.length || type === MemberPrivTypes.UNIFIED_DISCOUNT; // 是否有数据

    if ((isHDL && hasData && isMember) || (!isHDL && hasData)) {
      // 会员
      dispatch(
        setDiscountToOrder({
          ...res.data,
          ableAddPriceDiscount: discountRule.ableAddPriceDiscount, // 是否开启会员加价折扣
        }),
      );
    } else {
      dispatch(
        setDiscountToOrder({
          ...discountRule,
          isMember,
        }),
      );
    }
    sessionStorage.removeItem('orderId');
  });
};
exports.fetchDishMarketInfos = () => (dispatch, getState) => {
  const isHDL = getState().isHDL;
  const hdlParam = getToShopFlagParam();
  return fetchHelper
    .get(`${config.getDishMarketInfosAPI}?shopId=${shopId}${hdlParam}`)
    .then((marketInfoData = {}) => {
      if (!marketInfoData) {
        return {};
      }

      if (isHDL || !marketInfoData.discountInfo || !marketInfoData.discountInfo.dishList || !marketInfoData.discountInfo.dishList.length) {
        marketInfoData.discountInfo = {};
      }

      dispatch(setNormalDiscount(marketInfoData));

      // return marketInfoData.discountInfo;
      return {
        ...marketInfoData.discountInfo,
        ableAddPriceDiscount: marketInfoData.ableAddPriceDiscount,
      };
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg({ text: err.msg }));
      return {};
    });
};

exports.clearErrorMsg = () => (dispatch, getState) => dispatch(setErrorMsg({}));

// 如果session中有tableId的话将table信息读取出来展示在页面上
exports.fetchTableInfo = () => dispatch => {
  if (!addDishStatus) {
    // 在加菜模式下不会刷新 scanTableType
    /* 设定之前先清除 */
    sessionStorage.removeItem('scanTableType');
    /*
    新的 scanTableType = 1
    老的 scanTableType = 2
    */
    if (tableId) {
      sessionStorage.scanTableType = 2;
    } else if (tableKey) {
      sessionStorage.scanTableType = 1;
    }
  }
  let urlString = '';
  if (tableId || tableKey) {
    const tableStr = tableId ? 'tableId' : 'tableKey';
    urlString = `&${tableStr}=${tableId || tableKey}`;
    return fetchHelper.get(`${config.getTableInfoAPI}?shopId=${shopId}${urlString}`, null, { enableDefaultResponseResolve: false }).then((res = {}) => {
      const table = res.data || {};
      if (table && table.code === '200' && !!table.data) {
        sessionStorage.setItem('tableId', table.data.synFlag);
        localStorage.setItem('kcTableId', table.data.synFlag);
        dispatch(setTableAreaInfo(table.data));
      } else {
        errorLocation(table.code, table.msg);
      }
    });
  }
  return null;
};

// 优惠券礼包，多张优惠券
exports.getMarketCoupons = (couponId, callBack) => (dispatch, getState) => {
  dispatch(
    setLoadMsg({
      status: true,
      word: formatMessage(actionText2.actiongettingCoupon),
    }),
  );
  // 根据需求判断新老接口
  const { isOldMarketing, ruleId, planId } = getState().shopInfo;
  let params = '';

  if (isOldMarketing) {
    params = `${config.fetchCouponAPI}?shopId=${shopId}&couponId=${couponId}`;
  } else {
    params = `${config.sendCouponsAPI}?shopId=${shopId}&ruleId=${ruleId}&planId=${planId}`;
  }
  return fetchHelper.get(params, null, { enableDefaultResponseResolve: false }).then((response = {}) => {
    const result = response.data || {};
    dispatch(setLoadMsg({ status: false, word: '' }));

    if (result.code === '200') {
      if (isOldMarketing) {
        // 老逻辑
        dispatch(setCouponSuccessInfo(result.data.coup));
      } else {
        // 新逻辑
        dispatch(setCouponSuccess(result.data)); // true 成功  false 失败
      }

      // 领券成功关闭掉领券页面
      if (callBack) {
        callBack();
      }
    } else if (result.code === '60200') {
      dispatch(setErrorMsg({ text: formatMessage(actionText2.actionRetryToGet) }));
    } else if (result.code === '110000') {
      dispatch(setErrorMsg({ text: result.msg }));
    } else {
      if (result.code === 'NOT_LOGIN') {
        // 用户未登录
        setTimeout(() => {
          pageHelper.navigateToLoginPage({
            shopId,
            getCoupon: true,
          });
        }, 800);
      }
    }
  });
};

/**
 * 跳转到商品详情页
 * @param {Object} goods 商品信息
 */
exports.gotoGoodsDetailPage = goods => dispatch => {
  if (!goods) {
    return;
  }

  const { id } = goods;
  const params = { ...getUrlParams(), dishId: id };

  // 跳转前设置sessionstorage
  sessionStorage.setItem('dishId', id);
  httpRequest.goto(router.goodsDetailURL, params);
};

// 必点菜 - 外卖
exports.fetchMustOrderMenu = () => (dispatch, getState) => {
  const { shopInfo = {} } = getState();
  if (orderType !== 'WM' || !shopInfo.enableOpenDish) {
    return Promise.resolve(false);
  }

  return fetchHelper.get(config.mustOrderDishListAPI, { shopId, type: 'WM' })
    .then((res = []) => {
      const self = res.filter(item => item.strategyType === STRATEGY_TYPE.SELFCHOOSE && !item.clearStatus) || [];

      const selfChooseDishTypeObj = self.reduce((all, cur) => {
        const list = all[cur.dishTypeId] ? all[cur.dishTypeId].concat(cur) : [cur];
        all[cur.dishTypeId] = list;
        return all;
      }, {});

      dispatch(setMustOrderDishList({
        selfChooseDishList: self,
        selfChooseDishTypeObj,
      }));
      return self;
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg(err.msg));
    });
};



// WEBPACK FOOTER //
// ./src/action/dish-menu/dish-menu.js